import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import store from "../store"
import CustomTabs from "./custom-tabs";
import StepEdit from "./step-edit.js"
import StepResults from "./step-result.js";
import { useStepIndex } from "./step-index-context";

const TABS = [
  {
    label: 'Edit transaction',
    disabled: false
  },
  {
    label: 'Execution result',
    disabled: false
  }
]

export default function StepViewEdit() {

  store.useRerenderIfChange(() => [
    stepIndex,    
    store.steps.length,    
  ])
  
  const onTabChange = (tabIndex) => {
    if (tabIndex == 0) {
      setViewOrEdit("edit");
    } else {
      setViewOrEdit("result");
    }
  }
  
  function onChange(newSteps) {
    store.steps = newSteps
    store.updateStore()
  }
  
  function setCollapse(index, newValue) {
    var newSteps = store.steps.concat()
    if (!newValue) {
      newSteps.forEach(step => (step.collapsed = true))
    }
    newSteps[index].collapsed = newValue
    onChange(newSteps)
    console.log(12)
  }
  
  store.useRerenderIfChange(() => [store.viewOrEdit, store.isLoadingResults]);
  
  function setViewOrEdit(newValue) {
    store.viewOrEdit = newValue
    store.updateStore()
  }
  
  const getActiveTab = () => {
    return store.viewOrEdit == "edit" ? 0 : 1;
  }
  var isOneSide=store.getView()=="oneside"
  var stepIndex=useStepIndex()
  


  var ref=useRef(null)
  useLayoutEffect(()=>{
    if(!store.leftWidth) {
      var left
      if(localStorage.leftWidth) {
        left=localStorage.leftWidth
      } else {
        var fullWidth=ref.current.getBoundingClientRect().width
        left=fullWidth/2
      }
      if(left!=store.leftWidth) {
        store.leftWidth=left
        store.updateStore()
      }
    }
  },[])



  function start(e){
    window.addEventListener("mouseup",stop)
    window.addEventListener("mousemove",move)

    function stop(){
      window.removeEventListener("mouseup",stop)
      window.removeEventListener("mousemove",move)
    }
    function move(e){
      // start(e)
      // set_startResizeX(e.pageX)
      var diff=e.pageX-ref.current.getBoundingClientRect().left
      if(diff<120) {
        diff=120
      }
      store.leftWidth=diff
      localStorage.leftWidth=store.leftWidth
      store.updateStore()
      e.preventDefault()
      e.stopPropagation()
      return false
    }

  }
  store.useRerenderIfChange(()=>[
    store.leftWidth
  ])

  var isDefaultStep=store.steps[stepIndex]?.['defaultStep']

  return (
      <div css={`
      background:${isOneSide ? 'white' :''};
      color:${isDefaultStep ? 'rgb(158, 158, 158)' : 'unset'}
      `} ref={ref}>
          <div css={`display:flex;`}>
              <div css={`
              max-width:${store.leftWidth}px;
              min-width:${store.leftWidth}px;
              overflow-x:auto;`}>
                <StepEdit
                key={store.steps[stepIndex].uid}
                collapse={false}
                setCollapse={setCollapse.bind(null, stepIndex)}
                  />
            </div>
            <div 
              css={`background:#ddd;cursor:ew-resize;width:5px;`}
              onMouseDown={start}
            >
            </div>
            <div css={`flex-grow:1;overflow-x:auto`}>
                <StepResults />
            </div>
          </div>
      </div>
  )
}
